import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { forIn, isEqual, toPairs, without } from 'lodash';
import { NarrowByFilter, FilterItem } from './NarrowBy.filter'
import { FormattedMessage, injectIntl } from 'react-intl';
import {
    ENTITIES_FILTER_ALL_ENTITIES,
    ENTITIES_FILTER_CATEGORIES,
    ENTITIES_FILTER_SPECIFIC,
    APPLIED_FILTERS_TOOLTIP_MAX_WIDTH
} from '../../../../../constants';
import utils from '../../../../../utils/utilities';

class NarrowByGroupedFilter extends NarrowByFilter {

    constructor(props) {
        super(props);

        this.filters = {
            ...this.filters,
            risk:     {
                ...this.filters.risk,
                individual: () => {

                    if (!this.filters.risk.areAllSelected()) {
                        let riskItems = toPairs(this.props.filtersState.filters.risk)
                            .filter(item => item[1])
                            .map(risk => <FormattedMessage
                                key={risk[0]}
                                id={`Dashboard_CoreFunctionality_UIText_dashboard.${risk[0]}RiskLevel`} />);

                        return (<FilterGroupedItem label={"Dashboard_Charts_UIText_dashboard.filters.riskLevels"}
                                                   intlInput={true}>
                            {riskItems}
                        </FilterGroupedItem>)
                    }

                }
            },
            entities: {
                ...this.filters.entities,
                individual: () => {
                    if (this.props.categories) {
                        switch (this.props.filtersState.filters.entities.type) {
                            case ENTITIES_FILTER_CATEGORIES: {
                                if (this.props.readOnly) {
                                    let categoryItems = this.props.filtersState.filters.entities.categories.categoriesId.map(
                                        entity =>
                                            this.props.categories ? this.props.categories[entity] : null
                                    );
                                    if (this.props.filtersState.filters.entities.categories.allCategories) {
                                        categoryItems.push(<FormattedMessage
                                            id="Dashboard_Charts_UIText_dashboard.filters.allAssigned" />)
                                    }
                                    if (this.props.filtersState.filters.entities.categories.allUnassigned) {
                                        categoryItems.push(<FormattedMessage
                                            id="Dashboard_Charts_UIText_dashboard.filters.allUnassigned" />)
                                    }
                                    return (
                                        <FilterGroupedItem
                                            label={"Dashboard_Charts_UIText_dashboard.filters.categories"}
                                            intlInput={this.props.filtersState.filters.entities.categories.allCategories ||
                                            this.props.filtersState.filters.entities.categories.allUnassigned}>
                                            {categoryItems}
                                        </FilterGroupedItem>)
                                } else {

                                    let categoryItems = this.props.filtersState.filters.entities.categories.categoriesId.map(
                                        category =>
                                            <FilterItem key={category}
                                                        readOnly={this.props.readOnly}
                                                        closeHandler={(e) => this.filters.entities.uncheckCategoryAction(
                                                            category)}>
                                                {this.props.categories[category]}
                                            </FilterItem>
                                    )
                                    if (this.props.filtersState.filters.entities.categories.allCategories) {
                                        categoryItems.push(<FilterItem key={"allCategories"}
                                                                       readOnly={this.props.readOnly}
                                                                       closeHandler={(e) => this.filters.entities.uncheckAction(
                                                                           "allCategories")}>
                                            <FormattedMessage
                                                id="Dashboard_Charts_UIText_dashboard.filters.allAssigned" />
                                        </FilterItem>)
                                    }
                                    if (this.props.filtersState.filters.entities.categories.allUnassigned) {
                                        categoryItems.push(<FilterItem key={"allUnassigned"}
                                                                       readOnly={this.props.readOnly}
                                                                       closeHandler={(e) => this.filters.entities.uncheckAction(
                                                                           "allUnassigned")}>
                                            <FormattedMessage
                                                id="Dashboard_Charts_UIText_dashboard.filters.allUnassigned" />
                                        </FilterItem>)
                                    }
                                    return categoryItems

                                }
                            }
                            case ENTITIES_FILTER_SPECIFIC: {
                                if (this.props.filtersState.filters.entities.entitiesId.length) {
                                    if (this.props.readOnly) {
                                        let entityItems = this.props.filtersState.filters.entities.entitiesId.map(
                                            entity =>
                                                this.props.entities ? this.props.entities[entity] : null
                                        );

                                        return (<FilterGroupedItem
                                            label={"Dashboard_Charts_UIText_dashboard.filters.entities"}>
                                            {entityItems}
                                        </FilterGroupedItem>)
                                    } else {
                                        let entityItems = this.props.filtersState.filters.entities.entitiesId.map(
                                            entity =>
                                                this.props.entities ?
                                                    (<FilterItem key={entity}
                                                                 readOnly={this.props.readOnly}
                                                                 closeHandler={(e) => this.filters.entities.uncheckAction(
                                                                     entity)}>
                                                        {this.props.entities[entity]}
                                                    </FilterItem>)
                                                    : null
                                        )
                                        return entityItems
                                    }
                                } else {
                                    return <FilterItem key={ENTITIES_FILTER_ALL_ENTITIES}
                                                       readOnly={this.props.readOnly}>
                                        <FormattedMessage id="RSS_Add_UIText_addRssFeed.thirdParties.selectAll" />
                                    </FilterItem>
                                }
                            }
                            case ENTITIES_FILTER_ALL_ENTITIES: {
                                // this is handled in general function above
                                break;
                            }
                        }
                    }
                }
            },
            pestle:   {
                ...this.filters.pestle,
                individual: () => {
                    if (!this.filters.pestle.areAllSelected()) {
                        let pestleItems = toPairs(this.props.filtersState.filters.pestle)
                            .filter(item => item[1])
                            .map(pestle => (<FormattedMessage key={pestle[0]}
                                                              id={"General_CoreFunctionality_UIText_general." +
                                                              pestle[0]} />));

                        return (<FilterGroupedItem label={"Dashboard_Charts_UIText_dashboard.filters.riskAngles"}
                                                   intlInput={true}>
                            {pestleItems}
                        </FilterGroupedItem>)

                    }
                }
            },
            language: {
                ...this.filters.language,
                individual: () => {
                    if (!this.filters.language.areAllSelected()) {

                        let languageItems = toPairs(this.props.filtersState.filters.language)
                            .filter(item => item[1])
                            .map(language => <FormattedMessage
                                key={language[0]}
                                id={`Dashboard_Charts_UIText_dashboard.filters.language.${language[0]}`} />);

                        return (
                            <FilterGroupedItem label={"Dashboard_Charts_UIText_dashboard.filters.languageFilter"}
                                               intlInput={true}>
                                {languageItems}
                            </FilterGroupedItem>)


                    }
                }
            }

        }
        this.setFiltersOrder(props);

    }
}

export default injectIntl(NarrowByGroupedFilter);

class FilterGroupedItem extends Component {
    static propTypes = {
        label:     PropTypes.string,
        intlInput: PropTypes.bool
    }

    static defaultProps = {
        label:     null,
        intlInput: false
    }

    constructor(props) {
        super(props);
        this.tooltipRef = React.createRef();

        this.state = {
            tooltipWidth: 0
        }
    }

    createLabel = () => {
        if (this.props.intlInput) {
            if (this.props.children.length > 1) {
                return (<span>{this.props.children[0]}...</span>);
            } else {
                return (<span>{this.props.children[0]}</span>);
            }
        } else {
            if (this.props.children.length > 1) {
                if (this.props.children[0] && this.props.children[0].length < 10) {
                    return (<span>{this.props.children[0]}...</span>);
                } else {
                    return (<span>{utils.toEllipsis(this.props.children[0], 10)}</span>)
                }
            } else {
                return (<span>{this.props.children[0]}</span>);
            }
        }
    }

    componentDidMount() {
        let tooltipWidth = 12; // for tooltip with padding of 10px total, and 2px total borders
        if (this.tooltipRef.current) {
            for (let i = 0; i < this.tooltipRef.current.children.length; i++) {
                let elementWidth = this.tooltipRef.current.children[i].getBoundingClientRect().width;
                tooltipWidth = tooltipWidth + elementWidth;
                // once inline width exceeds 500, max-width 500px limits the width no matter the set inline width
                if (tooltipWidth > APPLIED_FILTERS_TOOLTIP_MAX_WIDTH) {break;}
            }
            this.setState({
                tooltipWidth: tooltipWidth
            })
        }
    }

    render() {
        return (
            <div className="filter-grouped-item">
                <div>{this.props.intl.formatMessage({id: this.props.label})}: <span>{this.createLabel()}</span></div>
                <div className="tooltip-mask" />
                {                     
                    this.props.children.length > 1 &&
                    <div className="tooltip" style={{width: this.state.tooltipWidth}} ref={this.tooltipRef}>
                        {this.props.children.map((child, index) => {
                            return <span key={index}>{child}</span>
                        })}
                    </div>
                }
            </div>

        )
    }
}

FilterGroupedItem = injectIntl(FilterGroupedItem);
export { FilterGroupedItem };


// WEBPACK FOOTER //
// ./src/scripts/pages/StartPage/Dashboard/components/FilterPod/NarrowByGrouped.filter.jsx